import type { InputComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import type { PatientContactDetailsFormSectionProps } from './PatientContactDetailsProcessActivityFormSection';
import { PatientContactDetailsFormSection } from './PatientContactDetailsProcessActivityFormSection';

export function getPatientContactDetailsComponent({
    alert,
    showAddress,
}: PatientContactDetailsFormSectionProps): InputComponentsMap<'patient'> {
    const map: InputComponentsMap<'patient'> = new Map();

    map.set(
        'patient',
        <PatientContactDetailsFormSection
            alert={alert}
            showAddress={showAddress}
        />
    );

    return map;
}
